import React from 'react';
import { Fragment } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import '../../../styles/itens.scss';
import { Link } from 'react-router-dom';


const ItemBox = (props) => {
    return (
        <Fragment>
            <Row xs={1}>
                <Col xs={12}>
                    <div className="filtra_lic">
                        <div className="titulo-home">{props.titulo}</div>
                        <div className="conteudo-lic">
                        
                            {props.texto}
                            { props.link ?
                            <a href={props.link}>
                                <Button variant='primary' type='button'>Veja aqui</Button>
                            </a> : ''}
                        </div>
                    </div>
                </Col>
            </Row>
        </Fragment>
    )
}

export default ItemBox;